export const mediaData = [
  {
    id: 1,
    name: "วิดีโอโปรโมชั่น 11.11",
    product: "รองเท้าวิ่งรุ่น Pro-X",
    type: "video",
    thumbnail: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=300&fit=crop",
    channels: {
      facebook: {
        id: 'facebook',
        name: 'Facebook',
        score: 85,
        roas: 5.2,
        cpa: 150,
        ctr: 2.5,
        spent: 10000,
        conversions: 66,
        clicks: 2500,
        impressions: 100000,
        cpc: 4,
        cpm: 100,
        cvr: 2.64,
        revenue: 52000,
        reach: 75000,
        engagement: 1250
      },
      instagram: {
        id: 'instagram',
        name: 'Instagram',
        score: 92,
        roas: 6.8,
        cpa: 120,
        ctr: 3.2,
        spent: 8000,
        conversions: 67,
        clicks: 2560,
        impressions: 80000,
        cpc: 3.1,
        cpm: 100,
        cvr: 2.62,
        revenue: 54400,
        reach: 65000,
        engagement: 1680
      },
      tiktok: {
        id: 'tiktok',
        name: 'TikTok',
        score: 65,
        roas: 3.4,
        cpa: 220,
        ctr: 1.8,
        spent: 12000,
        conversions: 55,
        clicks: 1800,
        impressions: 100000,
        cpc: 6.7,
        cpm: 120,
        cvr: 3.06,
        revenue: 40800,
        reach: 85000,
        engagement: 2100
      },
      youtube: {
        id: 'youtube',
        name: 'YouTube',
        score: 38,
        roas: 1.8,
        cpa: 350,
        ctr: 1.2,
        spent: 15000,
        conversions: 43,
        clicks: 1200,
        impressions: 100000,
        cpc: 12.5,
        cpm: 150,
        cvr: 3.58,
        revenue: 27000,
        reach: 90000,
        engagement: 890
      }
    }
  },
  {
    id: 2,
    name: "แบนเนอร์ลดราคาพิเศษ",
    product: "เสื้อผ้าแฟชั่น",
    type: "image",
    thumbnail: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=300&fit=crop",
    channels: {
      facebook: {
        id: 'facebook',
        name: 'Facebook',
        score: 78,
        roas: 4.5,
        cpa: 180,
        ctr: 2.1,
        spent: 8000,
        conversions: 44,
        clicks: 1680,
        impressions: 80000,
        cpc: 4.8,
        cpm: 100,
        cvr: 2.62,
        revenue: 36000,
        reach: 60000,
        engagement: 920
      },
      instagram: {
        id: 'instagram',
        name: 'Instagram',
        score: 88,
        roas: 5.9,
        cpa: 140,
        ctr: 2.8,
        spent: 7000,
        conversions: 50,
        clicks: 1960,
        impressions: 70000,
        cpc: 3.6,
        cpm: 100,
        cvr: 2.55,
        revenue: 41300,
        reach: 55000,
        engagement: 1380
      }
    }
  },
  {
    id: 3,
    name: "วิดีโอรีวิวสินค้า",
    product: "อุปกรณ์ออกกำลังกาย",
    type: "video",
    thumbnail: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    channels: {
      facebook: {
        id: 'facebook',
        name: 'Facebook',
        score: 72,
        roas: 4.1,
        cpa: 200,
        ctr: 1.9,
        spent: 9000,
        conversions: 45,
        clicks: 1710,
        impressions: 90000,
        cpc: 5.3,
        cpm: 100,
        cvr: 2.63,
        revenue: 36900,
        reach: 70000,
        engagement: 1140
      },
      youtube: {
        id: 'youtube',
        name: 'YouTube',
        score: 82,
        roas: 5.1,
        cpa: 160,
        ctr: 2.4,
        spent: 11000,
        conversions: 69,
        clicks: 2640,
        impressions: 110000,
        cpc: 4.2,
        cpm: 100,
        cvr: 2.61,
        revenue: 56100,
        reach: 95000,
        engagement: 1850
      }
    }
  }
];

export const getScoreColor = (score) => {
  if (score >= 81) return 'text-green-600 bg-green-100';
  if (score >= 61) return 'text-green-500 bg-green-50';
  if (score >= 41) return 'text-yellow-600 bg-yellow-100';
  if (score >= 21) return 'text-orange-600 bg-orange-100';
  return 'text-red-600 bg-red-100';
};

export const getScoreLabel = (score) => {
  if (score >= 81) return 'ยอดเยี่ยม';
  if (score >= 61) return 'ดี';
  if (score >= 41) return 'ปานกลาง';
  if (score >= 21) return 'ต้องปรับปรุง';
  return 'ประสิทธิภาพต่ำมาก';
};

export const channelIcons = {
  facebook: '📘',
  instagram: '📷',
  tiktok: '🎵',
  youtube: '📺'
};

export const channelColors = {
  facebook: 'bg-blue-500',
  instagram: 'bg-pink-500',
  tiktok: 'bg-black',
  youtube: 'bg-red-500'
};